import { render } from "./ChangePasswordForm.vue?vue&type=template&id=522fc946&scoped=true"
import script from "./ChangePasswordForm.vue?vue&type=script&lang=js"
export * from "./ChangePasswordForm.vue?vue&type=script&lang=js"

import "./ChangePasswordForm.vue?vue&type=style&index=0&id=522fc946&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-522fc946"]])

export default __exports__